import Loading from '../loading/skeleton';

export default function RowLoading() {
    return (
        <div className="p-4 bg-[#141414] text-white rounded-2xl mb-4">
            {/* Header */}
            <div className="flex justify-between w-24 items-center gap-x-2">
                <Loading isLoading className="w-24 h-4" children={undefined} />
            </div>

            {/* Type */}
            <Loading
                isLoading
                className="mt-3 w-16 h-5 rounded-md"
                children={undefined}
            />

            {/* Details */}
            <div className="mt-3 flex justify-between text-sm">
                <div className="w-20 h-4">
                    <Loading
                        isLoading
                        className="mt-1 w-20 h-4 rounded-md"
                        children={undefined}
                    />
                </div>
                <div className="w-20 h-4">
                    <Loading
                        isLoading
                        className="mt-1 w-16 h-4 rounded-md"
                        children={undefined}
                    />
                </div>
                <div className="w-20 h-4">
                    <Loading
                        isLoading
                        className="mt-1 w-10 h-4 rounded-md"
                        children={undefined}
                    />
                </div>
            </div>

            {/* Price */}
            <div className="mt-5 text-sm w-20 h-4">
                <Loading
                    isLoading
                    className="mt-1 w-20 h-4 rounded-md"
                    children={undefined}
                />
            </div>

            {/* Buttons */}
            <div className="flex gap-x-2 mt-4">
                <Loading
                    isLoading
                    className="flex-1 h-10 rounded-lg"
                    children={undefined}
                />
                <Loading
                    isLoading
                    className="flex-1 h-10 rounded-lg"
                    children={undefined}
                />
            </div>
        </div>
    );
}
